module.exports = __webpack_public_path__ + "img/2.88007cd8.png";